import React, { Fragment } from 'react';
import Header from '../layout/header/singlePageHeader';
import Footer from '../layout/footer/footer-5';
import Card from '../container/element/card/card-team-3';


const TeamGrid = () => {
    return (
        <Fragment>

            <Header pageTitle='Global Management Team'/>
            <section className="section-padding2 section-bg">
                <div className="card-style team--card3">
                    <div className="container">
                        <Card />
                        <Card />
                    </div>
                </div>
            </section>
            <Footer />
        </Fragment>
    )
}

export default TeamGrid;